"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Console = void 0;
var index_1 = require("../index");
/**
 * consoleをiframeで表示します。
 *
 * @class Console
 */
var Console = /** @class */ (function () {
    function Console() {
        //
    }
    /**
     * 準備
     */
    Console.init = function () {
        // 自身が開こうとしている場合はキャンセルする
        if (location.href.indexOf(Console.path) != -1)
            return;
        if (Console.inited)
            return;
        Console.inited = true;
        // style要素を作成
        var styleElm = document.createElement('style');
        styleElm.innerHTML = "\n#" + Console.elemIdName + "{\nbackground-color:white;\nposition:fixed;\nz-index:1998;\nbottom:0;\nleft:0;\nwidth:0%;\nheight:0%;\nborder:solid 1px black;\npadding:0;\nmargin:0;\n-webkit-transition: all 0.3s ease-out 0s;\ntransition: all 0.3s ease-out 0s;\n}\n\n.is-open #" + Console.elemIdName + "{\nwidth:calc(100vw - 46px);\nheight:calc(100vh - 46px);\n}\n\n#" + Console.elemIdName + "-btn{\nbackground-color: transparent;\nborder: none;\ncursor: pointer;\noutline: none;\npadding: 0;\nappearance: none;\nposition:fixed;\nz-index:1999;\nbottom:10px;\nleft:10px;\nwidth:46px;\nheight:46px;\n// background-color:red;\noverflow:hidden;\ndisplay:flex;\njustify-content: center;\nalign-items: center;\n}\n#" + Console.elemIdName + "-btn > div{\nwidth:80%;\nheight:80%;\nbackground-color:white;\nborder: solid 1px black;\nborder-radius: 50%;\noverflow:hidden;\n}\n#" + Console.elemIdName + "-btn > div> svg{\nwidth:100%;\nheight:100%;\n}\n#" + Console.elemIdName + "-btn ." + Console.elemIdName + "-btn__icon1{\ndisplay:block;\n}\n.is-open #" + Console.elemIdName + "-btn ." + Console.elemIdName + "-btn__icon1{\ndisplay:none;\n}\n#" + Console.elemIdName + "-btn ." + Console.elemIdName + "-btn__icon2{\ndisplay:none;\n}\n.is-open #" + Console.elemIdName + "-btn ." + Console.elemIdName + "-btn__icon2{\ndisplay:block;\n}\n.is-open #" + Console.elemIdName + "-btn{\nbottom:auto;\nleft:auto;\ntop:23px;\nright:23px;\n}\n}";
        document.getElementsByTagName('body')[0].appendChild(styleElm);
        // iframe要素を作成
        var iframeElm = document.createElement('iframe');
        iframeElm.setAttribute('id', Console.elemIdName);
        // consoleのURLkvsapiを与える
        var path = Console.path + (index_1.CsBsKvs.path ? '?kvsapi=' + index_1.CsBsKvs.path : '');
        iframeElm.setAttribute('src', path);
        document.getElementsByTagName('body')[0].appendChild(iframeElm);
        // button要素を作成
        var buttonElm = document.createElement('button');
        buttonElm.setAttribute('id', Console.elemIdName + '-btn');
        buttonElm.innerHTML = "\n    <div class=\"" + Console.elemIdName + "-btn__icon1\">\n    <svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24px\" viewBox=\"0 0 24 24\" width=\"24px\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-4 4v3c0 .22-.03.47-.07.7l-.1.65-.37.65c-.72 1.24-2.04 2-3.46 2s-2.74-.77-3.46-2l-.37-.64-.1-.65C8.03 15.48 8 15.23 8 15v-4c0-.23.03-.48.07-.7l.1-.65.37-.65c.3-.52.72-.97 1.21-1.31l.57-.39.74-.18c.31-.08.63-.12.94-.12.32 0 .63.04.95.12l.68.16.61.42c.5.34.91.78 1.21 1.31l.38.65.1.65c.04.22.07.47.07.69v1zm-6 2h4v2h-4zm0-4h4v2h-4z\"/></svg>\n    </div>\n    <div class=\"" + Console.elemIdName + "-btn__icon2\">\n    <svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24px\" viewBox=\"0 0 24 24\" width=\"24px\" fill=\"#000000\"><path d=\"M0 0h24v24H0V0z\" fill=\"none\"/><path d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z\"/></svg>\n    </div>\n    ";
        document.getElementsByTagName('body')[0].appendChild(buttonElm);
        // 開閉処理
        buttonElm.addEventListener('click', function () {
            if (Console.isOpen)
                Console.hide();
            else
                Console.show();
        });
    };
    /**
     * 表示
     */
    Console.show = function () {
        if (!Console.inited)
            return;
        if (Console.isOpen)
            return;
        Console.isOpen = true;
        var elem = document.getElementsByTagName('body')[0];
        if (elem)
            elem.classList.add('is-open');
    };
    /**
     * 非表示
     */
    Console.hide = function () {
        if (!Console.inited)
            return;
        if (!Console.isOpen)
            return;
        Console.isOpen = false;
        var elem = document.getElementsByTagName('body')[0];
        if (elem)
            elem.classList.remove('is-open');
    };
    // 開くページのパス
    Console.path = '/open/app/debug-tools/csbc-kvslib-console';
    // 準備済みかどうか
    Console.inited = false;
    // 開いているかどうか
    Console.isOpen = false;
    // 要素のID名
    Console.elemIdName = 'csbc-kvslib-console';
    return Console;
}());
exports.Console = Console;
//# sourceMappingURL=Console.js.map